var _style;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSingularLoader(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      whiteSpace: "pre"
    },
    width: 500,
    viewBox: "89 99 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, "@keyframes a0_o{0%,to{opacity:.2}33.3333%{opacity:1}}@keyframes a1_o{0%,to{opacity:.2}33.3333%{opacity:1}}@keyframes a2_o{0%,to{opacity:.2}33.3333%{opacity:1}}@keyframes a3_o{0%,to{opacity:.2}33.3333%{opacity:1}}@keyframes a4_o{0%,to{opacity:.2}33.3333%{opacity:1}}@keyframes a5_o{0%,to{opacity:.2}33.3333%{opacity:1}}")), /*#__PURE__*/React.createElement("path", {
    className: "singular_loader_svg__st0",
    d: "M98.745 108.76s1.747-1.41 1.41-4.057c-.037.074-1.852 3.584-5.302 2.872 0 .007 1.867 1.582 3.892 1.185z",
    opacity: 0.2,
    fill: "#3893f5",
    style: {
      animation: "a0_o 1.8s linear infinite both"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "singular_loader_svg__st0",
    d: "M94.328 110.41s2.744.42 3.84-1.223c0 0-3.42.338-5.573-3.044 0 0-.292 2.91 1.733 4.267z",
    opacity: 0.2,
    fill: "#3893f5",
    style: {
      animation: "a1_o 1.8s linear .3s infinite both"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "singular_loader_svg__st0",
    d: "M90.293 107.237s.757 1.898 2.744 2.61c0 0-2.144-2.954 0-6.337 0 0-2.377 1.32-2.744 3.727z",
    opacity: 0.2,
    fill: "#3893f5",
    style: {
      animation: "a2_o 1.8s linear .6s infinite both"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "singular_loader_svg__st0",
    d: "M90.945 102.032s-1.567 1.508-1.035 4.328c0 0 1.455-3.87 5.46-3.743-.007 0-1.92-1.567-4.425-.585z",
    opacity: 0.2,
    fill: "#3893f5",
    style: {
      animation: "a3_o 1.8s linear .9s infinite both"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "singular_loader_svg__st0",
    d: "M95.955 100.052s-3.21-.457-4.32 1.298c0 0 3.742-.698 5.752 2.812 0 0 .488-2.782-1.432-4.11z",
    opacity: 0.2,
    fill: "#3893f5",
    style: {
      animation: "a4_o 1.8s linear 1.2s infinite both"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "singular_loader_svg__st0",
    d: "M99.892 103.435s-.667-2.107-2.947-3.172c0 0 2.565 2.954-.112 6.502 0 0 2.617-.405 3.06-3.33z",
    opacity: 0.2,
    fill: "#3893f5",
    style: {
      animation: "a5_o 1.8s linear 1.5s infinite both"
    }
  }));
}
export default SvgSingularLoader;